import { DropDownItem, DropDownItemTyped } from '../shared/drop-down-item.model';
import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class EnumTranslationService {
  constructor(private translateService: TranslateService) {
  }

  public translateEnum<EnumType>(enumType: EnumType, translationBase: string, isNumericEnum: boolean = false): DropDownItem[] {
    const dropDownItems = this.convertToTranslationStrings(enumType, translationBase, isNumericEnum);
    this.translateDropDownItems(dropDownItems);
    return dropDownItems;
  }

  // eslint-disable-next-line max-len
  public convertToTranslationStrings<EnumType>(enumType: EnumType, translationBase: string, isNumericEnum: boolean = false): DropDownItem[] {
    const dropDownItems: DropDownItem[] = [];

    if (!enumType || !translationBase) {
      return dropDownItems;
    }
    for (const enumMember in enumType) {
      if (enumMember && isNaN(Number(enumMember))) {
        // for numeric enums, the member list returns both key and value
        // hence filterout values
        dropDownItems.push({
            key: enumMember,
            value: translationBase + enumMember
          } as DropDownItem);
      }
    }

    return dropDownItems;
  }

  public translateDropDownItems(dropDownItems: DropDownItem[]): DropDownItem[] {
    dropDownItems.forEach(item => {
      item.value = this.translateService.instant(item.value);
    });

    return dropDownItems;
  }

  /**
   *
   * @param {EnumType} enumType
   * @param {string} translationBase
   * @param {number[]} exclude Add any enum values that should be excluded from the dropdown
   * @returns
   */
  public translateNumericEnum<EnumType>(enumType: EnumType, translationBase: string, exclude?: number[]): DropDownItemTyped<EnumType>[] {
    const dropDownItems:  DropDownItemTyped<EnumType>[] = [];
    for(const enumMember in enumType) {
      if (enumMember) {
        if (Number(enumMember) >= 0 && (!exclude || !exclude.includes(Number(enumMember)))){
          dropDownItems.push({
            value: +enumMember as any,
            text: translationBase + enumType[enumMember]?.toString()
          } as DropDownItemTyped<EnumType>);
        }
      }
    }
    return dropDownItems;
  }

  public translateStringEnum<EnumType>(enumType: EnumType, translationBase: string): DropDownItemTyped<EnumType>[] {
    const dropDownItems:  DropDownItemTyped<EnumType>[] = [];
    for(const enumMember in enumType) {
      if (enumMember) {
        dropDownItems.push({
          value: enumMember as any,
          text: translationBase + enumMember
        } as DropDownItemTyped<EnumType>);
      }
    }
    return dropDownItems;
  }
}
